var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-sidebar"},[_c('div',{staticClass:"the-sidebar__logo"},[_vm._t("logo")],2),_c('nav',{staticClass:"the-sidebar__menu"},[_vm._t("menu")],2),_c('div',{staticClass:"the-sidebar__profile"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }